module.exports = __webpack_public_path__ + "img/num_layout_10.13ea1f75.png";